import React, { Component } from 'react';
import moment from 'moment';
import { searchDevicesV2, setDropModalOpen } from 'redux/actions';
import {
  isObjectsEqual,
  bundleIdsToDeviceIds,
  deviceToProductTypeDisplayString,
  arrayWithIDToDictionary,
  getDonorUnitFromBundleMembers,
  mixedDeviceIdArrayToDeviceIdArray
} from 'common/utils/helpers';
import { defaultSearchBody, DEVICES_PAGE_TAB } from 'common/utils/constants';
import MouseflowHelper from 'common/MouseflowHelper';
import Modal from 'components/shared/Modal/Modal';
import SearchBar from 'components/shared/SearchBar/SearchBar';
import { SingleCalendar } from 'components/shared/CalendarFilter/CalendarFilter';
import DropModal from 'components/shared/DropModal/DropModal';
import classNames from 'classnames';
import SvgAF, { IconAndText } from 'components/shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { SoftwareDownloadDeviceTable } from '../SoftwareDownloadDeviceTable/SoftwareDownloadDeviceTable';
import { SoftwareVersionList } from '../SoftwareVersionList/SoftwareVersionList';
import { DeviceTypeCheckbox } from '../DeviceTypeCheckbox/DeviceTypeCheckbox';
import { appConfig } from 'config';
import { SW_DOWNLOAD_SELECTION_TEXTS } from '../utils';
import '../SoftwareDownloadModal.css';

class BulkSoftwareDownloadModal extends Component {
  constructor(props) {
    super(props);
    this.MouseflowHelper = new MouseflowHelper();

    let time = moment();
    time.add(1, 'hour');
    this.state = {
      selectedDay: new Date(Date.now()),
      selectedIndex: 0,
      dateText: time.format('MMM D, YYYY'),
      timeText: time.format('hh:mm a'),
      timeWindowActive: false,
      dateWindowActive: true,
      stage: 'LIST',
      searchString: '',
      isTransferDateValid: true,
      isActivationDateValid: true,
      localSelectedDevicesDictionary: {},
      isDevicesLoaded: false,
      targetSwVersion: null,
      targetSwVersionIndex: null,
      clearTransferScheduleModal: false,
      clearActivationScheduleModal: false,
      transferDateText: null,
      transferTimeText: null,
      activationDateText: null,
      activationTimeText: null,
      displayMode: 'CONFIG',
      transferMode: null,
      activationMode: null,
      isDoneReady: false,
      selectedDeviceTypes: null,
      selectedSWVersionID: null,
      isEditClicked: false,
      hasNoAvailableSwVersion: false,
      isLoaded: false,
      renderKey: 0
    };

    this.handleDayClick = this.handleDayClick.bind(this);
    this.selectTimeOnClick = this.selectTimeOnClick.bind(this);

    this.isVerizon1Env = appConfig.webBaseUrl === 'https://ibms-ui-verizon1.azurewebsites.net';
  }

  handleDayClick(day) {
    let mmnt = moment(day.toISOString());
    this.setState({
      dateWindowActive: true,
      timeWindowActive: false,
      selectedDay: day,
      dateText: mmnt.format('MMM D, YYYY')
    });
  }

  selectTimeOnClick(time) {
    this.setState({ timeText: time, timeWindowActive: false });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.transferDateText !== this.state.transferDateText ||
      prevState.transferTimeText !== this.state.transferTimeText
    ) {
      let activationDateText = null;
      let activationTimeText = null;
      let transferDateTimeString = this.state.transferDateText + ' ' + this.state.transferTimeText;
      let currentHour = moment(transferDateTimeString).hour();

      if (currentHour >= 18) {
        activationDateText = moment(transferDateTimeString).add(1, 'days').format('MMM D, YYYY');
        activationTimeText = moment(transferDateTimeString).add(0.5, 'hours').add(1, 'minute').format('hh:mm a');
      } else {
        activationDateText = moment(transferDateTimeString).format('MMM D, YYYY');
        activationTimeText = moment(transferDateTimeString).add(0.5, 'hours').add(1, 'minute').format('hh:mm a');
      }

      this.setState({ activationDateText, activationTimeText });
    }
    if (this.state.isDoneReady && this.props.actionPending === false && this.state.isEditClicked === false)
      this.setState({ displayMode: 'DETAILS' });

    if (this.state.isEditClicked && this.state.displayMode === 'DETAILS') this.setState({ displayMode: 'CONFIG' });
  }

  componentDidMount() {
    const { selectedDevicesDictionary, deviceIdList } = this.props;

    let targetDevices = mixedDeviceIdArrayToDeviceIdArray(this.props.deviceIdList, this.props.storedBundlesDictionary);
    let targetBody = {
      ...defaultSearchBody,
      filters: { deviceId: targetDevices }
    };

    this.props.dispatch(
      searchDevicesV2(
        targetBody,
        null,
        (result) => {
          let devicesDictionary = arrayWithIDToDictionary(result.devices);
          let bundlesDictionary = result.bundles;

          let selectedDeviceTypes = {};

          Object.keys(this.props.selectedDevicesDictionary).forEach((deviceId) => {
            let deviceObj = {};
            if (devicesDictionary[deviceId]) {
              deviceObj = devicesDictionary[deviceId];
              let forSwUpdate = true;
              let productType = deviceToProductTypeDisplayString(deviceObj, forSwUpdate);
              if (selectedDeviceTypes[productType]) {
                selectedDeviceTypes[productType].deviceIds[deviceId] = true;
              } else {
                selectedDeviceTypes[productType] = {
                  selected: true,
                  deviceIds: {
                    [deviceId]: true
                  }
                };
              }
            } else if (bundlesDictionary[deviceId]) {
              deviceObj = getDonorUnitFromBundleMembers(bundlesDictionary[deviceId].members);
              let productType = 'Pivot 5G';
              if (selectedDeviceTypes[productType]) {
                bundlesDictionary[deviceId].members.forEach((m) => {
                  selectedDeviceTypes[productType].deviceIds[m.id] = true;
                });
              } else {
                let dict = {};
                bundlesDictionary[deviceId].members.forEach((m) => {
                  dict[m.id] = true;
                });

                selectedDeviceTypes[productType] = {
                  selected: true,
                  deviceIds: dict
                };
              }
            }
          });

          let newSelectedDeviceTypes = JSON.parse(JSON.stringify(selectedDeviceTypes));

          if (this.props.source === 'bundleOverview') {
            let deviceIdsDict = {};

            this.props.bundleOverviewMembers.forEach((bm) => {
              deviceIdsDict[bm.deviceId] = true;
            });

            newSelectedDeviceTypes = {
              'Pivot 5G': {
                deviceIds: deviceIdsDict,
                selected: true
              }
            };
          }

          Object.keys(this.state.localSelectedDevicesDictionary).forEach((deviceId) => {
            let isSelected = this.state.localSelectedDevicesDictionary[deviceId];

            if (newSelectedDeviceTypes != null)
              Object.keys(newSelectedDeviceTypes).forEach((deviceType) => {
                let { deviceIds } = newSelectedDeviceTypes[deviceType];

                for (let curId of Object.keys(deviceIds)) {
                  if (deviceId === curId) {
                    newSelectedDeviceTypes[deviceType].deviceIds[curId] = isSelected;

                    if (!this.state.filteredLocalDeviceIds.includes(curId)) {
                      newSelectedDeviceTypes[deviceType].deviceIds[curId] = false;
                    }
                  }
                }

                newSelectedDeviceTypes[deviceType].selected = Object.keys(deviceIds).some(
                  (deviceId) => deviceIds[deviceId]
                );
              });
          });

          this.setState({ selectedDeviceTypes: newSelectedDeviceTypes });

          this.setState({ devicesDictionary: devicesDictionary });
          this.setState({ bundlesDictionary: bundlesDictionary });
          this.setState({ renderKey: this.state.renderKey++ });
          this.setState({ isLoaded: true });
        },
        (error) => {
          this.setState({ isLoaded: true });
        }
      )
    );

    this.setState({ localSelectedDevicesDictionary: this.props.selectedDevicesDictionary });
    this.setState({ filteredLocalDeviceIds: this.props.deviceIdList });

    let transferDateText = moment().format('MMM D, YYYY');
    let transferTimeText = moment().add(1, 'minute').format('hh:mm a');
    let activationDateText = moment().format('MMM D, YYYY');
    let activationTimeText = moment().add(0.5, 'hours').format('hh:mm a');

    this.setState({
      localSelectedDevicesDictionary: selectedDevicesDictionary,
      filteredLocalDeviceIds: deviceIdList,
      transferDateText,
      transferTimeText,
      activationDateText,
      activationTimeText
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (
      !isObjectsEqual(this.state, nextState) ||
      this.props.displayTextType !== nextProps.displayTextType ||
      this.props.actionPending !== nextProps.actionPending
    ) {
      return true;
    } else {
      return false;
    }
  }

  render() {
    let selectedDevicesLength = Object.entries(this.state.localSelectedDevicesDictionary).filter(
      ([k, v]) => v === true && this.state.filteredLocalDeviceIds.includes(k)
    ).length;

    let dateErrorMessage = null;
    let transferDateTime = moment(this.state.transferDateText + ' ' + this.state.transferTimeText);
    let activationDateTime = moment(this.state.activationDateText + ' ' + this.state.activationTimeText);
    let duration = moment.duration(activationDateTime.diff(transferDateTime));

    let minuteDiff = duration.asMinutes();
    if (minuteDiff <= 0) {
      dateErrorMessage = 'Activation cannot be scheduled prior to Download completion.';
    }

    if (minuteDiff < 30) {
      dateErrorMessage = 'Allow a minimum of 30 minutes for the download(s) to complete.';
    }

    return (
      <Modal
        closeTargetRef={this.props.modalTargetRef}
        close={this.props.afterModalClose} //note that this only runs if you close the modal using the "closing" prop
        animate={this.props.animateModalClose}
        animateX={false}
        global
        closing={this.props.closeModal}
        noPadding
        height={800}
        width={1200}
      >
        <div className="BulkSoftwareDownloadModal">
          <div className="BulkSoftwareDownloadModal_DeviceList_Div">
            <div className="BulkSoftwareDownloadModal_DevicesSelected_Div">
              <span className="BulkSoftwareDownloadModal_DevicesSelected_Number">{selectedDevicesLength + ' '}</span>
              <span>Total device(s) selected</span>
            </div>

            <DeviceTypeCheckbox
              hasCheckbox={this.state.displayMode !== 'DETAILS' && !this.props.hideCheckbox}
              parent={this}
              selectedDeviceTypes={this.state.selectedDeviceTypes}
              localSelectedDevicesDictionary={this.state.localSelectedDevicesDictionary}
              devicesDictionary={this.state.devicesDictionary}
              bundlesDictionary={this.state.bundlesDictionary}
            />

            <div className="BulkSoftwareDownloadModal_SearchBar_Div">
              <div className="BulkSoftwareDownloadModal_SearchBar_InnerDiv">
                <SearchBar
                  defaultText={'Search'}
                  searchQuery={(searchString) => {
                    if (searchString) {
                      let newFilteredLocalDeviceIds = this.props.deviceIdList.filter((fd) => {
                        return (
                          this.state.devicesDictionary[fd]?.id?.includes(searchString) ||
                          (this.state.bundlesDictionary[fd]?.members != null &&
                            this.state.bundlesDictionary[fd].members.find((d) => {
                              return (
                                (d.id && d.id.includes(searchString)) ||
                                (d.tags?.userLabel && d.tags.userLabel.includes(searchString))
                              );
                            })) ||
                          (this.state.bundlesDictionary[fd]?.name &&
                            this.state.bundlesDictionary[fd].name.toLowerCase().includes(searchString.toLowerCase())) ||
                          (this.state.bundlesDictionary[fd]?.code &&
                            this.state.bundlesDictionary[fd].code.toLowerCase().includes(searchString.toLowerCase()))
                        );
                      });

                      this.setState({ filteredLocalDeviceIds: newFilteredLocalDeviceIds });
                    } else {
                      this.setState({ filteredLocalDeviceIds: this.props.deviceIdList });
                    }
                  }}
                />
              </div>
            </div>
            <SoftwareDownloadDeviceTable
              displayMode={this.state.displayMode}
              hasCheckbox={this.state.displayMode !== 'DETAILS' && !this.props.hideCheckbox}
              parent={this}
              isLoaded={this.state.isLoaded}
              dispatch={this.props.dispatch}
              deviceIdList={this.props.deviceIdList}
              filteredLocalDeviceIds={this.state.filteredLocalDeviceIds}
              selectedDeviceTypes={this.state.selectedDeviceTypes}
              devicesDictionary={this.state.devicesDictionary}
              bundlesDictionary={
                this.props.source === 'bundleOverview'
                  ? { [this.props.rawBundle.bundleId]: this.props.rawBundle }
                  : this.state.bundlesDictionary
              }
              displayTextType={this.props.displayTextType}
              localSelectedDevicesDictionary={this.state.localSelectedDevicesDictionary}
            />
          </div>
          {this.state.displayMode === 'CONFIG' && (
            <form onSubmit={(e) => e.preventDefault()} id="bulkForm" className="BulkSoftwareDownloadModal_ConfigPanel">
              <div className="BulkSoftwareDownloadModal_ConfigPanel_Title">Select a version to update or rollback</div>

              <SoftwareVersionList
                parent={this}
                softwareVersions={this.props.softwareVersions}
                selectedSWVersionID={this.state.selectedSWVersionID}
                selectedDeviceTypes={this.state.selectedDeviceTypes}
              />

              <div className="BulkSoftwareDownloadModal_ConfigPanel_Title TransferTitle">
                When should the software start to be transferred to the devices?
              </div>

              <div
                className={classnames({
                  BulkSoftwareDownloadModal_ConfigPanel_ScheduleButtons: true
                })}
              >
                <button
                  className={classNames('BulkSoftwareDownloadModal_ConfigPanel_ScheduleButtons_StartNow', {
                    selected: this.state.transferMode === 'NOW' && this.state.transferDateText
                  })}
                  onClick={() => {
                    this.setState({
                      transferMode: 'NOW',
                      transferDateText: moment().format('MMM D, YYYY'),
                      transferTimeText: moment().add(1, 'minute').format('hh:mm a')
                    });
                  }}
                >
                  Immediately
                </button>
                <DropModal
                  title={
                    this.state.transferDateText && this.state.transferMode === 'SCHEDULE' ? (
                      <span className="BulkSoftwareDownloadModal_ConfigPanel_ScheduleButtons_Title">
                        {`${this.state.transferTimeText} on ${this.state.transferDateText}`}
                      </span>
                    ) : (
                      <IconAndText
                        img={IconLoader.icon_schedule_bttn}
                        hoverImg={IconLoader.icon_schedule_bttn_hover}
                        text={'Schedule'}
                      />
                    )
                  }
                  onClick={() => {
                    this.setState({ transferMode: null });
                  }}
                  isActive={this.state.transferMode === 'SCHEDULE' && this.state.transferDateText}
                  name={'scheduleSwDownload'}
                  forceClose={this.state.transferMode === 'SCHEDULE'}
                >
                  <SingleCalendar
                    isDateValid={(isValid) => this.setState({ isTransferDateValid: isValid })}
                    sendDate={(date) => {
                      if (moment(date + ' ' + this.state.transferTimeText).isValid())
                        this.setState({ transferDateText: date });
                    }}
                    sendTime={(time) => {
                      if (moment(this.state.transferDateText + ' ' + time).isValid())
                        this.setState({ transferTimeText: time });
                    }}
                    timeMode
                    inputDateText={this.state.transferDateText}
                    inputTimeText={this.state.transferTimeText}
                  />
                  <div className="BulkSoftwareDownloadModal_TransferScheduleDropModal_ButtonRow">
                    <button
                      className="BulkSoftwareDownloadModal_Calendar_CancelButton"
                      onClick={() => {
                        this.setState({ clearTransferScheduleModal: true }, () => {
                          this.setState({ clearTransferScheduleModal: false });
                        });
                        this.props.dispatch(setDropModalOpen('scheduleSwDownload', false));
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className={'BulkSoftwareDownloadModal_Calendar_ScheduleButton Global_RoundedButton'}
                      disabled={
                        !this.state.isTransferDateValid ||
                        !moment(this.state.transferDateText + ' ' + this.state.transferTimeText).isValid()
                      }
                      onClick={() => {
                        this.setState({ transferMode: 'SCHEDULE' });
                      }}
                    >
                      Schedule
                    </button>
                  </div>
                </DropModal>
              </div>
              {this.state.transferMode !== null && (
                <div className="BulkSoftwareDownloadModal_Explanation_Text_Box">
                  <SvgAF img={IconLoader.icon_info_small} />
                  <span className="BulkSoftwareDownloadModal_Explanation_Text">
                    {this.state.transferMode === 'SCHEDULE'
                      ? SW_DOWNLOAD_SELECTION_TEXTS.downloadStart.SCHEDULE(
                          `${this.state.transferTimeText} on ${this.state.transferDateText}`
                        )
                      : SW_DOWNLOAD_SELECTION_TEXTS.downloadStart.NOW()}
                  </span>
                </div>
              )}
              <div className="BulkSoftwareDownloadModal_ConfigPanel_Title TransferTitle">
                When should the activation start?
              </div>

              <div
                className={classnames({
                  BulkSoftwareDownloadModal_ConfigPanel_ActivationScheduleButtons: true
                })}
              >
                <button
                  className={classNames('BulkSoftwareDownloadModal_ConfigPanel_ScheduleButtons_DownloadCompleted', {
                    selected: this.state.activationMode === 'NOW'
                  })}
                  onClick={() => {
                    let activationDateText = null;
                    let activationTimeText = null;
                    let transferDateTimeString = this.state.transferDateText + ' ' + this.state.transferTimeText;
                    let currentHour = moment(transferDateTimeString).hour();
                    if (currentHour >= 18) {
                      activationDateText = moment(transferDateTimeString).add(1, 'days').format('MMM D, YYYY');
                      activationTimeText = moment(transferDateTimeString)
                        .add(0.5, 'hours')
                        .add(1, 'minute')
                        .format('hh:mm a');
                    } else {
                      activationDateText = moment(transferDateTimeString).format('MMM D, YYYY');
                      activationTimeText = moment(transferDateTimeString)
                        .add(0.5, 'hours')
                        .add(1, 'minute')
                        .format('hh:mm a');
                    }
                    this.setState({ activationMode: 'NOW', activationDateText, activationTimeText });
                  }}
                >
                  When download is complete
                </button>
                <DropModal
                  title={
                    this.state.activationDateText && this.state.activationMode === 'SCHEDULE' ? (
                      <span className="BulkSoftwareDownloadModal_ConfigPanel_ActivationScheduleButtons_Title">
                        {`${this.state.activationTimeText} on ${this.state.activationDateText}`}
                      </span>
                    ) : (
                      <IconAndText
                        img={IconLoader.icon_schedule_bttn}
                        hoverImg={IconLoader.icon_schedule_bttn_hover}
                        text={'Schedule'}
                      />
                    )
                  }
                  onClick={() => {
                    this.setState({ activationMode: null });
                  }}
                  isActive={this.state.activationMode === 'SCHEDULE'}
                  name={'scheduleSwActivation'}
                  forceClose={this.state.activationMode === 'SCHEDULE'}
                >
                  <SingleCalendar
                    isDateValid={(isValid) => this.setState({ isActivationDateValid: isValid })}
                    sendDate={(date) => {
                      if (moment(date + ' ' + this.state.activationTimeText).isValid())
                        this.setState({ activationDateText: date });
                    }}
                    sendTime={(time) => {
                      if (moment(this.state.activationDateText + ' ' + time).isValid())
                        this.setState({ activationTimeText: time });
                    }}
                    timeMode
                    inputDateText={this.state.activationDateText}
                    inputTimeText={this.state.activationTimeText}
                  />
                  <div className="BulkSoftwareDownloadModal_ActivationScheduleDropModal_ButtonRow">
                    <button
                      className="BulkSoftwareDownloadModal_Calendar_CancelButton"
                      onClick={() => {
                        this.setState({ clearActivationScheduleModal: true }, () => {
                          this.setState({ clearActivationScheduleModal: false });
                        });
                        this.props.dispatch(setDropModalOpen('scheduleSwActivation', false));
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className={'BulkSoftwareDownloadModal_Calendar_ScheduleButton Global_RoundedButton'}
                      disabled={
                        !this.state.isActivationDateValid ||
                        !moment(this.state.activationDateText + ' ' + this.state.activationTimeText).isValid()
                      }
                      onClick={() => {
                        this.setState({ activationMode: 'SCHEDULE' });
                      }}
                    >
                      Schedule
                    </button>
                  </div>
                </DropModal>
              </div>
              {dateErrorMessage && (
                <span className="BulkCreateDevicesListModal_ConfigPanel_ErrorMessage">{dateErrorMessage}</span>
              )}
              {this.state.activationMode !== null && !dateErrorMessage && (
                <div className="BulkSoftwareDownloadModal_Explanation_Text_Box">
                  <SvgAF img={IconLoader.icon_info_small} />
                  <span className="BulkSoftwareDownloadModal_Explanation_Text">
                    {this.state.activationMode === 'SCHEDULE'
                      ? SW_DOWNLOAD_SELECTION_TEXTS.activationStart.SCHEDULE(
                          `${this.state.activationTimeText} on ${this.state.activationDateText}`
                        )
                      : SW_DOWNLOAD_SELECTION_TEXTS.activationStart.NOW()}
                  </span>
                </div>
              )}

              <div className="BulkSoftwareDownloadModal_ConfigPanel_FinishButtons">
                <button
                  className="BulkSoftwareDownloadModal_ConfigPanel_FinishButtons_CancelButton"
                  onClick={() => {
                    this.setState({
                      targetSwVersion: null,
                      selectedSWVersionID: null,
                      transferMode: null,
                      activationMode: null
                    });
                    this.props.afterModalClose();
                  }}
                >
                  Cancel
                </button>

                <button
                  className="BulkSoftwareDownloadModal_ConfigPanel_FinishButtons_ContinueButton"
                  disabled={
                    this.state.transferMode === null ||
                    this.state.activationMode === null ||
                    this.state.targetSwVersion == null ||
                    selectedDevicesLength === 0 ||
                    dateErrorMessage ||
                    this.state.hasNoAvailableSwVersion ||
                    this.state.selectedSWVersionID === null
                  }
                  onClick={(event) => {
                    event.preventDefault();

                    this.setState({ isDoneReady: true, isEditClicked: false });
                  }}
                >
                  Continue
                </button>
              </div>
            </form>
          )}
          {this.state.displayMode === 'DETAILS' && (
            <div className="BulkSoftwareDownloadModal_DetailsPanel">
              <div className="BulkSoftwareDownloadModal_DetailsPanel_TitleMessage">
                Please review your selection below
              </div>
              <div className="BulkSoftwareDownloadModal_DetailsPanel_DetailBlock">
                <div className="BulkSoftwareDownloadModal_DetailsPanel_DetailBlock_Title">Software version</div>
                <div className="BulkSoftwareDownloadModal_DetailsPanel_DetailBlock_Value">
                  {this.state.targetSwVersion.sw_version}
                </div>
              </div>
              <div className="BulkSoftwareDownloadModal_DetailsPanel_DetailBlock BulkSoftwareDownloadModal_DetailsPanel_DetailBlock_DateTime">
                <div className="BulkSoftwareDownloadModal_DetailsPanel_DetailBlock_Title">
                  This update will start {this.state.transferMode === 'SCHEDULE' ? 'at' : ''}
                </div>
                <div className="BulkSoftwareDownloadModal_DetailsPanel_DetailBlock_Value">
                  {this.state.transferMode === 'NOW'
                    ? 'immediately'
                    : `${this.state.transferTimeText} on ${this.state.transferDateText}`}
                </div>
              </div>
              <div className="BulkSoftwareDownloadModal_DetailsPanel_DetailBlock BulkSoftwareDownloadModal_DetailsPanel_DetailBlock_DateTime">
                <div className="BulkSoftwareDownloadModal_DetailsPanel_DetailBlock_Title">
                  The activation will start {this.state.activationMode === 'SCHEDULE' ? 'at' : ''}
                </div>
                <div className="BulkSoftwareDownloadModal_DetailsPanel_DetailBlock_Value">
                  {this.state.activationMode === 'NOW'
                    ? 'when download is complete'
                    : `${this.state.activationTimeText} on ${this.state.activationDateText}`}
                </div>
                <div className="BulkSoftwareDownloadModal_DetailsPanel_DetailBlock_Value"></div>
              </div>
              <div className="BulkSoftwareDownloadModal_DetailsPanel_WarningBlock">
                <div className="BulkSoftwareDownloadModal_DetailsPanel_WarningBlock_Title">Please note:</div>
                <div className="BulkSoftwareDownloadModal_DetailsPanel_WarningBlock_Message">
                  Software Update is a service impacting operation. During the software activation phase the device will
                  reboot and this will interrupt the 5G service for up to 5 minutes.
                </div>
              </div>
              <div className="BulkSoftwareDownloadModal_ConfigPanel_FinishButtons_Container">
                <button
                  className="BulkSoftwareDownloadModal_ConfigPanel_FinishButtons_EditButton"
                  disabled={this.state.actionPending}
                  onClick={(event) => {
                    event.preventDefault();

                    this.setState({ displayMode: 'CONFIG', isEditClicked: true });
                  }}
                >
                  Edit
                </button>
                {this.props.actionPending ? (
                  <button className={'BulkSoftwareDownloadModal_ConfigPanel_FinishButtons_DoneButton'}>
                    <img
                      alt={'loading icon'}
                      className="DeviceConfigTable_Status_LoadingIcon"
                      src={IconLoader.icon_spinner_small}
                    />
                  </button>
                ) : (
                  <button
                    className="BulkSoftwareDownloadModal_ConfigPanel_FinishButtons_DoneButton"
                    disabled={
                      this.state.transferMode === null ||
                      this.state.activationMode === null ||
                      this.state.targetSwVersion == null
                    }
                    onClick={(event) => {
                      try {
                        event.preventDefault();

                        this.MouseflowHelper.submitAttempt('bulkForm');

                        let transferDate = null;
                        let activationDate = null;

                        if (this.state.transferMode === 'SCHEDULE') {
                          transferDate = moment(this.state.transferDateText);

                          if (this.state.transferTimeText) {
                            let mmntTime = moment(this.state.transferTimeText, 'hh:mm a');

                            transferDate.hour(mmntTime.hour());
                            transferDate.minute(mmntTime.minute());
                          }
                        } else if (this.state.transferMode === 'NOW') transferDate = 'now';

                        if (this.state.activationMode === 'SCHEDULE') {
                          activationDate = moment(this.state.activationDateText);

                          if (this.state.transferTimeText) {
                            let mmntTime = moment(this.state.activationTimeText, 'hh:mm a');

                            activationDate.hour(mmntTime.hour());
                            activationDate.minute(mmntTime.minute());
                          }
                        }

                        if (activationDate < transferDate && activationDate !== null) {
                          throw 'error activationDate < transferDate';
                        }

                        let selectedDevicesArray = Object.entries(this.state.localSelectedDevicesDictionary)
                          .filter(([k, v]) => v === true)
                          .map(([k, v]) => k);

                        let actualDevicesArray = [];
                        selectedDevicesArray.forEach((deviceId) => {
                          if (this.state.filteredLocalDeviceIds.includes(deviceId)) {
                            actualDevicesArray.push(deviceId);
                          }
                        });

                        this.props.initiateBulkSwUpgrade(
                          bundleIdsToDeviceIds(actualDevicesArray, this.state.bundlesDictionary),
                          this.state.targetSwVersion.sw_identifier,
                          this.state.transferMode === 'SCHEDULE' ? transferDate.format() : transferDate,
                          this.state.activationMode === 'SCHEDULE' ? activationDate.format() : null
                        );

                        this.MouseflowHelper.submitSuccess('bulkForm');
                      } catch (error) {
                        this.MouseflowHelper.submitFailure('bulkForm');

                        this.props.processError('Error trying to install sw version');
                      }
                    }}
                  >
                    Done
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      </Modal>
    );
  }
}

export default BulkSoftwareDownloadModal = connect((store) => {
  const activeTab = store.ui.devicesPage.activeTab;
  let displayTextType;
  if (activeTab === DEVICES_PAGE_TAB.pivot) {
    displayTextType = store.ui.devicesPage.pivotTab.deviceDisplayMode;
  } else if (activeTab === DEVICES_PAGE_TAB.echo) {
    displayTextType = store.ui.devicesPage.echoTab.deviceDisplayMode;
  } else {
    displayTextType = store.ui.devicesPage.allDevicesTab.deviceDisplayMode;
  }

  return {
    bulkActionModalOpen: store.ui.devicesPage.bulkActionModalOpen,
    displayTextType,
    storedBundlesDictionary: store.data.bundlesStorage.storedBundlesDictionary
  };
})(BulkSoftwareDownloadModal);
